<template>
  <div id="average-time" class="widget widget-height">
    <div class="title row">
      <h1>{{ $tr('analytics.widgets.averageTime.title') }}</h1>

      <img
        v-tooltip="{
          content: $tr('analytics.widgets.averageTime.helper'),
          placement: 'top-center',
          classes: 'tight'
        }"
        class="icon-first canvas-filter"
        src="/static/images/elements/icon_info.svg"
        alt="Info"
      />

      <img class="canvas-filter" src="/static/images/elements/icon_download.svg" alt="Download" @click="saveAsPng" />
    </div>

    <div v-if="loading" class="spinner-wraper">
      <div class="spinner"></div>
    </div>

    <div v-else class="main-content">
      <h1 class="title-thin">
        {{ days }} <span> {{ daysHint }} </span>
      </h1>
      <h2>{{ hours }} {{ hoursHint }}</h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import mixinSaveToPng from './mixinSaveToPng.js';
import Pluralize from '@/mixins/pluralize';

const secToHours = s => s / (60 * 60);
const hoursToDays = h => h / 24;

export default {
  name: 'WidgetAverageTime',

  mixins: [Pluralize, mixinSaveToPng],

  props: {
    filtersParams: Object
  },

  computed: {
    ...mapGetters({
      duration: 'analytics/averageTime/duration',
      loading: 'analytics/totalInterviewDuration/loading'
    }),

    hours() {
      return Math.round(secToHours(this.duration));
    },

    days() {
      return Math.floor(hoursToDays(this.hours));
    },

    daysHint() {
      return this.pluralize(this.$tr('analytics.time.day'), this.days);
    },

    hoursHint() {
      return this.pluralize(this.$tr('analytics.time.hourLoweCase'), this.hours);
    }
  },

  watch: {
    filtersParams() {
      this.fetch();
    }
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.$store.dispatch('analytics/averageTime/fetch', this.filtersParams);
    },

    saveAsPng() {
      this.mixinSaveAsPng({
        filename: `average-time_${this.filtersParams.created_after}_${this.filtersParams.created_before}`,
        saveId: 'average-time',
        filterClass: 'canvas-filter'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.widget {
  .spinner-wraper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }

  .spinner {
    margin: auto;
    height: 50px;
    width: 50px;
    margin-top: 0;
  }

  .main-content {
    h1.title-thin {
      margin-top: 4px;
      font-weight: 300;

      span {
        line-height: 68px;
        font-size: 48px;
        font-weight: 300;
      }
    }

    h2 {
      margin-top: 2px;
    }
  }
}
</style>
